import { Component, Input, OnInit } from '@angular/core';
import { SearchResult } from 'src/app/shared';
import { CommCenterService } from '../..';
import { ConversationSummary } from '../../models/ConversasationSummary';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-comm-center2-messages-card',
    template: `
    <app-panel
      title="Communication center"
      [headerLevel]="2"
      [canExpand]="true"
      >
      <app-loading-panel
        [state]="summary ? 'Loaded' : 'Loading'"
        loadingStyle="Box"
        [loadingHeight]="400"
        >
        <ng-template #content>
          @if (summary) {
            <app-comm-center2-messages
              [summary]="summary"
              [headerEnabled]="false"
              overflowHeight="500px"
              [focus]="focus"
              [claim]="claim"
              [translationRequest]="translationRequest"
              />
          }
        </ng-template>
      </app-loading-panel>
    </app-panel>
    `,
    styles: ``,
    standalone: false
})
export class CommCenter2MessagesCardComponent implements OnInit {
  @Input()
  claim: SearchResult;

  @Input()
  focus: boolean;

  @Input()
  translationRequest: TranslationRequest;
  

  summary: ConversationSummary;

  constructor(public commCenterService: CommCenterService) {}

  async ngOnInit() {
    this.summary = await this.commCenterService.createClaimConversation(
      this.claim
    );
  }
}
